import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import PerLocationCreativeItem from "./PerLocationCreativeItem";
import type { Creative, Location } from "../../types";

interface MediaOwnerCreativesProps {
  selectedLocations: Location[];
  /** Keyed by location name */
  locationCreatives: Record<string, Creative[]>;
  onLocationFileChange: (locationName: string, e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveLocationCreative: (locationName: string, index: number) => void;
  onUpdateLocationCreativeDays?: (locationName: string, creativeIndex: number, days: number[]) => void;
  isUploading: boolean;
  uploadingMap?: Record<string, boolean>;
  onLocationUrlSubmit?: (locationName: string, url: string, orientation?: "portrait" | "landscape") => void;
}

const MediaOwnerCreatives = ({
  selectedLocations,
  locationCreatives,
  onLocationFileChange,
  onRemoveLocationCreative,
  onUpdateLocationCreativeDays,
  isUploading,
  uploadingMap = {},
  onLocationUrlSubmit
}: MediaOwnerCreativesProps) => {
  const { t } = useLanguage();

  if (selectedLocations.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      {selectedLocations.map((location, idx) => (
        <PerLocationCreativeItem
          key={`${location.name}-${idx}`}
          location={location}
          creatives={locationCreatives[location.name] || []}
          onFileChange={onLocationFileChange}
          onRemoveCreative={onRemoveLocationCreative}
          onUpdateCreativeDays={onUpdateLocationCreativeDays}
          isUploading={uploadingMap[location.name] || isUploading}
          onUrlSubmit={onLocationUrlSubmit}
        />
      ))}
    </div>
  );
};

export default MediaOwnerCreatives;
